import { DestroyRef, Directive, ElementRef, OnInit, input, output, inject } from '@angular/core';
import { IrisLanguageI } from '@iris/common/models/IrisLanguage';
import { MatDialog } from '@angular/material/dialog';
import { IrisFieldTextTranslationsModalComponent } from '@iris/common/modules/fields/field-text/field-text-translations-modal/field-text-translations-modal.component';
import { take, tap, switchMap } from 'rxjs/operators';
import { fromEvent, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[translateManager]',
})
export class TranslateManagerDirective implements OnInit {
  dialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);

  languages = input<IrisLanguageI[]>(null);
  translations = input<unknown>(null);
  translatedFieldName = input<string>('');
  translationsChange = output<Record<string, unknown>>();

  btnElem: HTMLElement;

  constructor() {
    const el = inject(ElementRef);

    this.btnElem = el.nativeElement;
  }

  ngOnInit(): void {
    fromEvent(this.btnElem, 'click').pipe(
      switchMap(() => this.openTranslationModal()),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }

  openTranslationModal(): Observable<Record<string, unknown>> {
    return this.dialog.open(
      IrisFieldTextTranslationsModalComponent, {
        data: {
          languages: this.languages(),
          translatedFieldName: this.translatedFieldName(),
          translations: this.translations(),
        },
        maxWidth: '500px',
      }).componentInstance.onSetTranslations.pipe(
      take(1),
      tap((translations: Record<string, unknown>) => this.translationsChange.emit(translations)),
    );
  }
}
